import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Router } from '@angular/router';
import { filter, interval, Subscription } from 'rxjs';
import { VersionerUrlService } from 'src/app/core/services/versioner-url.service';
import { FlujoLinks, ApiResponse, ApiExplorerResponse, ExploreRequest } from 'src/app/models/verioner-url'; // Importa ApiResponse también
import Swal from 'sweetalert2';

@Component({
  selector: 'app-home-versioner',
  templateUrl: './home-versioner.component.html',
  styleUrls: ['./home-versioner.component.css']
})
export class HomeVersionerComponent implements OnInit {
  formUrl: FormGroup;
  loading: boolean = false;
  pollingInterval: Subscription | null = null; // Variable para almacenar la suscripción al polling
  currentUuid: string | null = null; // Almacena el UUID de la sesión actual
  modalAbierta = false;
  porcentajeProgressBar:number = 0;
  explorerPrompt: string = "";

  options = [
    { value: 'regular', image: 'https://d2yoo3qu6vrk5d.cloudfront.net/pulzo-dev/images-pulzo/logo-chatgpt.svg' },
    { value: 'alterno', image: 'https://d2yoo3qu6vrk5d.cloudfront.net/pulzo-dev/RonaldImages/gemini.png' },
  ];

  constructor(
    private fb: FormBuilder,
    private versionerService: VersionerUrlService,
    private router: Router
  ) { }

  atLeastTwoUrlsRequired(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const urls = [
        group.get('url1')?.value,
        group.get('url2')?.value,
        group.get('url3')?.value,
        group.get('url4')?.value
      ];
  
      const filledUrls = urls.filter(url => url && url.trim() !== '');
      return filledUrls.length >= 2 ? null : { atLeastTwoUrls: true };
    };
  }
  

  ngOnInit(): void {
    this.formUrl = this.fb.group({
      url1: ['', [Validators.pattern('(https?://.*)')]],
      url2: ['', [Validators.pattern('(https?://.*)')]],
      url3: ['', [Validators.pattern('(https?://.*)')]],
      url4: ['', [Validators.pattern('(https?://.*)')]],
      nombreIA: ['regular', Validators.required]
    }, {
      validators: [this.atLeastTwoUrlsRequired()]
    });
  }

  // Método para iniciar el polling
  private startPollingStatus(): void {
    // Si ya hay un polling en curso, lo detenemos para evitar múltiples suscripciones
    if (this.pollingInterval) {
      this.pollingInterval.unsubscribe();
    }

    console.log('Codigo uuid:', this.currentUuid)

    Swal.fire({
      title: 'Generando nueva versión',
      html: `
      <div style="margin: 20px 0;">
        <div class="swal2-loader" style="margin: auto; position: relative; bottom: 10px;"></div>
        <div style="width: 100%; background: #e0e0e0; border-radius: 5px; overflow: hidden;">
          <div id="progress-bar" style="width: 25%; height: 10px; background: #4caf50; transition: width 0.3s;"></div>
        </div>
        <div style="margin-top: 10px; font-size: 14px;">Espere un momento...</div>
      </div>
    `,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    // `interval(5000)` crea un Observable que emite un valor cada 5000ms (5 segundos).

    this.pollingInterval = interval(3000).pipe(
      filter(() => !!this.currentUuid)
    ).subscribe(() => {
      this.versionerService.queryVersionerStatus(this.currentUuid).subscribe({
        next: (responseStatus: any) => {

          if (responseStatus.estado !== "Finalizado") {

            if (!this.modalAbierta) {
              this.modalAbierta = true;
              Swal.fire({
                title: 'Espere por favor',
                html: `
              <div style="margin: 20px 0;">
                <div class="swal2-loader" style="margin: auto; position: relative; bottom: 10px;"></div>
                <div style="width: 100%; background: #e0e0e0; border-radius: 5px; overflow: hidden;">
                  <div id="progress-bar" style="width: 25%; height: 10px; background: #4caf50; transition: width 0.3s;"></div>
                </div>
                <div style="margin-top: 10px; font-size: 20px;" id="estado-text">${responseStatus.estado}</div>
              </div>
            `,
              
              allowOutsideClick: false,
              showConfirmButton: false,
                
              });
            } else {
              // Solo actualizas el contenido
              const estadoText = document.getElementById('estado-text');
              if (estadoText) estadoText.textContent = responseStatus.estado;


              const progressBar = document.getElementById('progress-bar');
              if (progressBar) {
                // Puedes actualizar el width según algún valor del estado
                
                this.porcentajeProgressBar = this.porcentajeProgressBar + 3;
                progressBar.style.width = this.porcentajeProgressBar + '%'; // o dinámico
              }
            }

          } else {
            if (this.pollingInterval) {
              this.pollingInterval.unsubscribe();
            }
            this.modalAbierta = false;
            Swal.close();
            sessionStorage.setItem('versionData', JSON.stringify(responseStatus));
            this.router.navigate(['/article-versioner']);
          }

        }
      });
    });

  };

  explorerVersionPrompt() {
    if (!this.explorerPrompt || this.explorerPrompt.trim() === '') {
      Swal.fire('', 'El campo requerido no puede estar vacío', 'warning');
      return;
    }
  
    const flujoLinks: ExploreRequest = {
      contenido: this.explorerPrompt
    };
  
    this.versionerService.exploreNewVersion(flujoLinks).subscribe({
      next: (response: ApiExplorerResponse) => {
        const uuid = response.uuid;
  
        if (uuid) {
          this.currentUuid = uuid;
          this.startPollingStatus();
        } else {
          console.error('UUID no presente en la respuesta.');
          Swal.fire('', 'Error en la respuesta de la API: UUID no encontrado.', 'error');
        }
      },
      error: (err) => {
        console.error('Error al generar la versión del artículo:', err);
        Swal.fire('', 'Error al generar la versión del artículo. Intente nuevamente.', 'error');
      }
    });
  }
  


  sendUrl() {
    if (this.formUrl.invalid) {
      Swal.fire('', 'Debes ingresar al menos dos URLs válidas para continuar', 'warning');
      return;
    }

    const flujoLinks: FlujoLinks = {
      tipo_flujo: this.formUrl.value.nombreIA,
      links: [
        this.formUrl.value.url1,
        this.formUrl.value.url2,
        this.formUrl.value.url3,
        this.formUrl.value.url4
      ].filter(link => link && link.trim() !== '') // Filtra URLs vacías/nulas
    };

    console.log('Enviando flujoLinks:', flujoLinks);

    this.versionerService.startVersioner(flujoLinks).subscribe({
      next: (response: ApiResponse) => { // Especificamos el tipo de respuesta como ApiResponse
        // Asumiendo que el backend retorna 'uuid' en la raíz o dentro de 'data'
        const uuid = response.uuid;


        if (uuid) {

          this.currentUuid = uuid; // Guarda el UUID
          this.startPollingStatus();



        } else {
          console.error('UUID no presente en la respuesta o estructura inesperada.');
          Swal.fire('', 'Error en la respuesta de la API: UUID no encontrado.', 'error');
        }
      },
      error: (err) => {
        console.error('Error al generar la versión del artículo:', err);
        Swal.fire('', 'Error al generar la versión del artículo. Intente nuevamente.', 'error');
      }
    });
  }
}